// 서버 UniqueCode enum 전체 미러링.(26.06.10 기준) - UI에서 별도 처리 하지 않는 것도 포함되어 있음.
export const UNIQUE_CODES = {
  // user (100xxx)
  INVALID_USER_ID: 100000,
  USER_TOKEN_NOT_FOUND: 100001,
  LICENSE_USER_LIMIT_EXCEEDED: 100002,
  ALREADY_UPDATED_TEMP_PASSWORD: 100003,
  TEMP_PASSWORD_NOT_CORRECT: 100004,
  CANNOT_BE_SAME_AS_TEMP_PASSWORD: 100005,
  CURRENT_PASSWORD_NOT_CORRECT: 100006,
  NOT_TEMP_PASSWORD: 100007,
  CANNOT_BE_SAME_AS_CURRENT_PASSWORD: 100008,
  INVALID_PASSWORD_FORMAT: 100009,
  EMAIL_NOT_FOUND: 100010,
  PASSWORD_NOT_CORRECT: 100011,
  USER_DEACTIVATED: 100012,
  LOGIN_REQUIRED_DEACTIVATED: 100013,
  READ_ONLY_USER: 100014,
  INVALID_USER_TOKEN: 100015,
  INACTIVATED_USER: 100016,
  EXPIRED_INVITATION_URL: 100017,
  INVITED_USER_MISMATCH: 100018,

  // storage (200xxx)
  INVALID_STORAGE_ITEM_ID: 200001,
  STORAGE_ITEM_NOT_FOUND: 200002,
  INVALID_DESTINATION_DIRECTORY_ID: 200003,
  DESTINATION_DIRECTORY_NOT_FOUND: 200004,
  SAME_NAME_IN_DIRECTORY_EXISTS: 200005,
  CANNOT_MOVE_TO_SUB_DIRECTORY: 200006,
  DESTINATION_IS_NOT_A_DIRECTORY: 200007,
  CANNOT_RENAME_ROOT_DIRECTORY: 200008,
  SAME_NAME_DIRECTORY_EXISTS: 200009,
  DIRECTORY_NOT_EMPTY: 200010,
  NOT_A_FILE: 200011,
  NOT_OWNER_CANNOT_MODIFY: 200012,
  PARENT_DIRECTORY_NOT_FOUND: 200013,
  INVALID_PARENT_DIRECTORY_ID: 200014,
  IMAGE_VALIDATION_EMPTY_FILE: 200100,
  IMAGE_VALIDATION_UNSUPPORTED_EXTENSION: 200101,
  IMAGE_VALIDATION_INVALID_HEADER: 200102,
  IMAGE_VALIDATION_INVALID_INPUT_STREAM: 200103,
  IMAGE_VALIDATION_CONVERSION_FAILED: 200104,
  IMAGE_VALIDATION_EMPTY_BYTE_ARRAY: 200105,
  IMAGE_VALIDATION_INCORRECT_FORMAT: 200106,
  FOLDER_IS_EMPTY: 200107,
  DATA_TYPE_MISMATCH: 200108,
  INVALID_VIDEO_FORMAT: 200109,
  FAILED_TO_UPLOAD_FILE: 2000110,

  // download (300xxx)
  DOWNLOAD_TOKEN_REQUIRED: 300001,
  INVALID_DOWNLOAD_TOKEN: 300002,

  // project (400xxx)
  INVALID_PROJECT_ID: 400000,
  PROJECT_NOT_FOUND: 400001,
  OCR_CHARACTER_SET_INVALID_UPPERCASE: 400003,
  OCR_CHARACTER_SET_INVALID_LOWERCASE: 400004,
  OCR_CHARACTER_SET_INVALID_NUMBERS: 400005,
  OCR_CHARACTER_SET_INVALID_SPECIAL_CHARACTERS: 400006,
  OCR_CHARACTER_SET_INVALID_CHARACTERS: 400007,
  PROJECT_CLASS_GROUP_JOB_IN_PROGRESS: 400100,
  PROJECT_CLASS_GROUP_LOCKED: 400101,
  NOT_A_MEMBER_OF_WORKSPACE: 400102,
  ALREADY_MEMBER_OF_PROJECT: 400103,
  PERMISSION_DENIED: 400104,
  DEPENDENT_NODE_EXISTS: 400105,
  PROJECT_CLASS_GROUP_IN_PROGRESS_LABELING: 400106,
  ALREADY_MEMBER_OF_WORKSPACE: 400107,
  NODES_DATASET_CATEGORY_MISMATCH: 400108,

  // dataset node (500xxx)
  DATASET_IS_IN_MODEL_PIPELINE: 500001,

  // labeling node (6000xxx)
  INVALID_LABELING_NODE_ID: 600001,
  LABELING_NODE_NOT_FOUND: 600002,
  LABELING_NODE_COMPLETE: 600003,
  LABELING_CLASS_NOT_FOUND: 600004,
  LABELING_CLASS_IDS_REQUIRED: 600005,
  LABELING_ANOMALY_SINGLE_CLASS: 600006,
  INVALID_REPORT_ID: 600007,
  LABELING_OCR_HAS_INVALID_CHARACTER: 600009,
  LABELING_OCR_TEXT_NOT_FOUND: 6000010,
  LABELING_OCR_NOT_FOUND: 6000011,
  LABELING_OCR_NOT_COMPLETED: 6000012,
  LABELING_NOT_STARTED: 6000013,
  REVIEW_NOT_STARTED: 6000014,
  LABELING_NODE_ALREADY_COMPLETE: 6000015,
  USER_NOT_ASSIGNED: 6000016,
  ANOMALY_MINIMUM_TRAINING_COUNT_NOT_MET: 6000017,
  LABELING_CLASS_NAME_ALREADY_EXISTS: 6000018,
  CANNOT_UNSET_CLASS_GROUP_WHILE_AI_JOB_RUNNING: 6000019,
  LABELING_CLS_NO_TAG: 6000020,
  // 라벨링 오브젝트와 학습 제외 영역(마스킹 오브젝트)이 서로 겹칠 때 발생
  LABELING_OBJECT_MASKING_OVERLAP: 6000021,

  // model node (700xxx)
  INVALID_MODEL_NODE_ID: 700001,
  MODEL_NODE_NOT_FOUND: 700002,
  MODEL_NODE_NOT_COMPLETED: 700003,
  MODEL_NODE_RETRY_REQUIRED: 700004,
  TABULAR_MODEL_INVALID_WINDOW_SIZE: 700005,
  TABULAR_MODEL_INVALID_OVERLAP_RATIO: 700006,
  OCR_ROI_INVALID_INTERSECTION: 700007,

  // model drift (800xxx)
  DATE_MISSING: 800001,
  DATE_INVALID_ALLOWED: 800002,
  TEST_DATA_INSUFFICIENT: 800003,
  MODEL_INVALID_ALLOWED: 800004,
  DATA_LIMIT_CONNECTION: 800005,
  TARGET_DATA_STREAMING_NODE_ALREADY_CONNECTED: 800006,
  TARGET_MODEL_NODE_ALREADY_CONNECTED: 800007,
  TARGET_DATASET_NODE_ALREADY_CONNECTED: 800008,
  TARGET_NODE_ALREADY_INFERENCE_SCHEMA: 800009,
  MODEL_DRIFT_NOT_COMPLETED: 800010,
  INFERENCE_SCHEMA_COUNT_MISMATCH: 800011,
  REFERENCE_DATA_INSUFFICIENT: 800012,

  // dqi (900xxx)
  DQI_NOT_COMPLETED: 900001,
  DATA_DRIFT_NODE_NOT_FOUND: 900002,
  INSUFFICIENT_TEST_IMAGES: 900003,
  INSUFFICIENT_NORMAL_IMAGES: 900004,
  DATA_DRIFT_DATE_MISSING: 900005,
  STREAM_NODE_MODEL_TYPE_UNSUPPORTED: 900006,
  ONLY_ONE_DATA_STREAMING_NODE_ALLOWED: 900007,
  ALREADY_CONNECTED_REFERENCE: 900008,
  LABELING_CLASS_GROUP_MISMATCH: 900009,

  // data collection (1000xxx)
  DATE_FIELD_REQUIRED: 1000001,
  DATA_FIELDS_CANNOT_BE_EMPTY: 1000002,
  INVALID_DATA_FIELD: 1000003,
  DATA_COLLECTION_INFO_NOT_FOUND: 1000004,
  DATA_COLLECTION_INVALID_API_KEY: 1000005,
  DATA_COLLECTION_STORAGE_NOT_FOUND: 1000006,
  INVALID_DATA_COLLECTION_INFO_ID: 1000007,
  INVALID_DATA_COLLECTION_ENDPOINT_ID: 1000008,
  DATA_COLLECTION_ENDPOINT_NOT_FOUND: 1000009,
  DATA_COLLECTION_CUSTOM_SCHEMA_NOT_FOUND: 1000010,
  INVALID_DATE_FORMAT: 1000011,
  DATA_COLLECTION_ENDPOINT_IN_USE: 1000012,
  DATA_COLLECTION_EXPORT_LIMIT_EXCEEDED: 1000013,

  // tasks (1100xxx)
  BATCH_TASK_NOT_FOUND: 1100001,
  BATCH_TASK_ITEM_NOT_FOUND: 1100002,
  CANNOT_RESTART_JOB: 1100003,
  IMAGE_TOO_SMALL_FOR_TILE: 1100004,
  TIME_SERIES_TRAINING_PRECONDITION_NOT_MET: 1100005,
  BATCH_TASK_REVIEW_PENDING: 1100006,
  BATCH_TASK_RUNNING: 1100007,
  RETRAIN_EVALUATION_THRESHOLD_RUNNING: 1100008,
  RETRAIN_DEPLOY_PENDING: 1100009,
  DRIFT_TASK_INCOMPLETE: 1100010,

  // file processing (1200xxx)
  FILE_PROCESSING_JOB_NOT_FOUND: 1200001,
  FILE_PROCESSING_JOB_NOT_COMPLETED: 1200002,

  // workspace (1300xxx)
  INVALID_WORKSPACE_ID: 1300001,
  WORKSPACE_NOT_FOUND: 1300002,
  NOT_WORKSPACE_OWNER: 1300003,
  WORKSPACE_MAX_MEMBERS_EXCEEDED: 1300004,

  // model pipeline (1400xxx)
  INSTANCE_NODE_INCOMPLETE: 1400001,
  GATE_NODE_INCOMPLETE: 1400002,
  NO_IMAGES_TO_RUN_INFERENCE: 1400003,
  INVALID_BASE_MODEL_PIPELINE_EDGE: 1400004,
  CANNOT_DELETE_TASK_IN_PROGRESS_GROUP_NODE: 1400005,
  GROUP_NODE_NOT_FOUND: 1400006,
  MODEL_PIPELINE_GATE_NODE_NOT_FOUND: 1400007,
  MODEL_PIPELINE_INSTANCE_NODE_NOT_FOUND: 1400008,
  MODEL_PIPELINE_MERGE_NODE_NOT_FOUND: 1400009,
  DELETE_INITIAL_INSTANCE_NODE_FORBIDDEN: 1400010,
  NO_IMAGES_TO_RUN_CROP: 1400011,
  CANNOT_DELETE_BRANCH_SETTINGS_NODE: 1400012,
  MERGE_NODE_ALREADY_EXISTS: 1400013,
  MERGE_NODE_CONNECTION_FORBIDDEN: 1400014,
  CANNOT_EXPORT_DELETED_REFERENCE_MODEL: 1400015,
  MODEL_PIPELINE_DOWNLOAD_NOT_READY: 1400016,

  // eda (1500xxx)
  EDA_HAS_MISSING_DATA: 1500001,
  DUPLICATE_REMOVE_METHOD_NOT_ALLOWED: 1500002,
  EDA_ALREADY_CONNECTED_TO_LABELING: 1500003,

  // model version (1600xxx)
  INVALID_MODEL_VERSION_ID: 1600001,
  MODEL_VERSION_NOT_FOUND: 1600002,
  MODEL_VERSION_RETRY_REQUIRED: 1600003,

  // external model (1700xxx)
  MAIN_FILE_NOT_FOUND: 1700000,
  INVALID_FILE_FORMAT: 1700001,
  DUPLICATE_FILES: 1700002,
  DUPLICATE_MODEL_NAME: 1700003,
  EXTERNAL_MODEL_IN_USE: 1700004,
  MANIFEST_FILE_REQUIRED: 1700005,
  MODEL_FILES_REQUIRED: 1700006,
  LOSS_FILES_REQUIRED: 1700007,
  INVALID_MANIFEST_JSON: 1700008,
  MANIFEST_MODEL_FILES_EMPTY: 1700009,
  MANIFEST_LOSS_FILES_EMPTY: 1700010,
  SCHEDULE_MANIFEST_ENTRIES_REQUIRED: 1700011,
  SCHEDULE_FILES_REQUIRED: 1700012,
  INVALID_MANIFEST_FILE_NAME: 1700013,
  CODE_FILE_NAME_MISMATCH: 1700014,
  EMPTY_CODE_FILE_NAME: 1700015,

  // credit (2000xxx)
  INSUFFICIENT_CREDIT: 2000001,

  // auto deploy (2100xxx)
  AUTO_DEPLOY_ENDPOINT_NOT_FOUND: 2100001,
  INVALID_AUTO_DEPLOY_ACCESS_KEY: 2100002,
  INVALID_AUTO_DEPLOY_ACCESS_SECRET: 2100003,
  AUTO_DEPLOY_SETTINGS_NOT_FOUND: 2100004,
  AUTO_DEPLOY_SETTINGS_EXPORT_FILE_NOT_FOUND: 2100005,
  AUTO_DEPLOY_SETTINGS_EXISTS: 2100006,

  // model retrain node (2200xxx)
  NO_TRAINED_NORMAL_IMAGES: 2200001,
  INSUFFICIENT_REFERENCE_IMAGES: 2200002,

  // tabular (3000xxx)
  EMPTY_FILTERED_RESULT: 3000001,
  CANNOT_PARSING_DATA: 3000002,
  TOO_MANY_LABEL: 3000003,
  REMOVE_OUTLIERS_NOT_COMPLETED: 3000004,
  DEPENDENT_COLUMN_ALREADY_SET: 3000005,

  // common (9000xxx)
  SERVER_ERROR: 9000000,
  INVALID_PARAMETER: 9000001,
} as const

// onError에서 처리되는 코드 목록 — ErrorBoundary로 throw하지 않음.
export const HANDLED_UNIQUE_CODES = [
  // user
  UNIQUE_CODES.READ_ONLY_USER,

  // storage
  UNIQUE_CODES.SAME_NAME_IN_DIRECTORY_EXISTS,
  UNIQUE_CODES.FOLDER_IS_EMPTY,
  UNIQUE_CODES.DATA_TYPE_MISMATCH,
  UNIQUE_CODES.INVALID_VIDEO_FORMAT,

  // project
  UNIQUE_CODES.PROJECT_CLASS_GROUP_JOB_IN_PROGRESS,
  UNIQUE_CODES.PROJECT_CLASS_GROUP_LOCKED,
  UNIQUE_CODES.PERMISSION_DENIED,
  UNIQUE_CODES.PROJECT_CLASS_GROUP_IN_PROGRESS_LABELING,
  UNIQUE_CODES.NODES_DATASET_CATEGORY_MISMATCH,

  // labeling node
  UNIQUE_CODES.USER_NOT_ASSIGNED,
  UNIQUE_CODES.ANOMALY_MINIMUM_TRAINING_COUNT_NOT_MET,
  UNIQUE_CODES.CANNOT_UNSET_CLASS_GROUP_WHILE_AI_JOB_RUNNING,
  UNIQUE_CODES.LABELING_CLS_NO_TAG,
  UNIQUE_CODES.LABELING_OBJECT_MASKING_OVERLAP,

  // model node
  UNIQUE_CODES.OCR_ROI_INVALID_INTERSECTION,

  // model drift
  UNIQUE_CODES.DATE_MISSING,
  UNIQUE_CODES.DATE_INVALID_ALLOWED,
  UNIQUE_CODES.TEST_DATA_INSUFFICIENT,
  UNIQUE_CODES.MODEL_INVALID_ALLOWED,
  UNIQUE_CODES.DATA_LIMIT_CONNECTION,
  UNIQUE_CODES.TARGET_DATA_STREAMING_NODE_ALREADY_CONNECTED,
  UNIQUE_CODES.TARGET_MODEL_NODE_ALREADY_CONNECTED, // NOTE: 별도 ui 처리 없음. 필요시 추가.
  UNIQUE_CODES.TARGET_DATASET_NODE_ALREADY_CONNECTED,
  UNIQUE_CODES.TARGET_NODE_ALREADY_INFERENCE_SCHEMA, // NOTE: 별도 ui 처리 없음. 필요시 추가.
  UNIQUE_CODES.MODEL_DRIFT_NOT_COMPLETED,
  UNIQUE_CODES.INFERENCE_SCHEMA_COUNT_MISMATCH,
  UNIQUE_CODES.REFERENCE_DATA_INSUFFICIENT,

  // dqi
  UNIQUE_CODES.DQI_NOT_COMPLETED,
  UNIQUE_CODES.INSUFFICIENT_TEST_IMAGES,
  UNIQUE_CODES.INSUFFICIENT_NORMAL_IMAGES,
  UNIQUE_CODES.DATA_DRIFT_DATE_MISSING,
  UNIQUE_CODES.STREAM_NODE_MODEL_TYPE_UNSUPPORTED,
  UNIQUE_CODES.ONLY_ONE_DATA_STREAMING_NODE_ALLOWED,
  UNIQUE_CODES.ALREADY_CONNECTED_REFERENCE,
  UNIQUE_CODES.LABELING_CLASS_GROUP_MISMATCH,

  // data collection
  UNIQUE_CODES.DATA_COLLECTION_ENDPOINT_IN_USE,

  // tasks
  UNIQUE_CODES.IMAGE_TOO_SMALL_FOR_TILE,
  UNIQUE_CODES.TIME_SERIES_TRAINING_PRECONDITION_NOT_MET,
  UNIQUE_CODES.BATCH_TASK_REVIEW_PENDING,
  UNIQUE_CODES.BATCH_TASK_RUNNING,
  UNIQUE_CODES.RETRAIN_EVALUATION_THRESHOLD_RUNNING,
  UNIQUE_CODES.RETRAIN_DEPLOY_PENDING,
  UNIQUE_CODES.DRIFT_TASK_INCOMPLETE,

  // workspace
  UNIQUE_CODES.WORKSPACE_MAX_MEMBERS_EXCEEDED,

  // model pipeline
  UNIQUE_CODES.INSTANCE_NODE_INCOMPLETE,
  UNIQUE_CODES.NO_IMAGES_TO_RUN_INFERENCE,
  UNIQUE_CODES.INVALID_BASE_MODEL_PIPELINE_EDGE,
  UNIQUE_CODES.CANNOT_DELETE_TASK_IN_PROGRESS_GROUP_NODE,
  UNIQUE_CODES.NO_IMAGES_TO_RUN_CROP,

  // model version
  UNIQUE_CODES.MODEL_VERSION_RETRY_REQUIRED,

  // external model
  UNIQUE_CODES.DUPLICATE_MODEL_NAME,
  UNIQUE_CODES.EXTERNAL_MODEL_IN_USE,
  UNIQUE_CODES.MANIFEST_FILE_REQUIRED,
  UNIQUE_CODES.MODEL_FILES_REQUIRED,
  UNIQUE_CODES.LOSS_FILES_REQUIRED,
  UNIQUE_CODES.INVALID_MANIFEST_JSON,
  UNIQUE_CODES.MANIFEST_MODEL_FILES_EMPTY,
  UNIQUE_CODES.MANIFEST_LOSS_FILES_EMPTY,
  UNIQUE_CODES.SCHEDULE_MANIFEST_ENTRIES_REQUIRED,
  UNIQUE_CODES.SCHEDULE_FILES_REQUIRED,
  UNIQUE_CODES.INVALID_MANIFEST_FILE_NAME,
  UNIQUE_CODES.CODE_FILE_NAME_MISMATCH,
  UNIQUE_CODES.EMPTY_CODE_FILE_NAME,

  // credit
  UNIQUE_CODES.INSUFFICIENT_CREDIT,

  // auto deploy
  UNIQUE_CODES.AUTO_DEPLOY_SETTINGS_EXISTS,

  // model retrain node
  UNIQUE_CODES.NO_TRAINED_NORMAL_IMAGES,
  UNIQUE_CODES.INSUFFICIENT_REFERENCE_IMAGES,

  // common
  UNIQUE_CODES.INVALID_PARAMETER,
]
